import t from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const d = {
  display: "block"
}, s = ({ size: a = 16, useVw: n, useRem: e, color: o, withColor: l, removeClassName: c, disableSSR: p, style: i, ...m }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ t.createElement(h, { disableSSR: p }, /* @__PURE__ */ t.createElement("svg", { "data-icon-id": "32px-shandui", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (e ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (e ? "rem" : "px"), className: c ? "" : "iconpark-icon", style: x, fill: "none", ...m }, /* @__PURE__ */ t.createElement(
    "g",
    {
      className: c ? "" : "32px-éªå"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        className: c ? "" : "normal",
        d: "M16 4.9c-4.007 0-7.52 2.123-9.472 5.31a.9.9 0 0 1-1.535-.941A12.893 12.893 0 0 1 16 3.1c6.747 0 12.284 5.18 12.852 11.78.099 1.15-.844 2.02-1.896 2.02H18.7c-1.214 0-1.87-1.425-1.08-2.347l2.393-2.79a.9.9 0 1 1 1.367 1.17L19.522 15.1h7.434a.123.123 0 0 0 .09-.034.052.052 0 0 0 .011-.017s.002-.005.001-.015C26.57 9.357 21.805 4.9 16 4.9ZM4.942 16.951s-.002.006 0 .015C5.43 22.643 10.194 27.1 16 27.1c4.007 0 7.519-2.123 9.472-5.31a.9.9 0 0 1 1.534.941A12.893 12.893 0 0 1 16 28.901c-6.747 0-12.284-5.18-12.852-11.78-.1-1.151.844-2.02 1.895-2.02h8.132c1.267 0 1.9 1.53 1.005 2.426l-2.76 2.763a.9.9 0 0 1-1.273-1.273l2.116-2.116h-7.22a.124.124 0 0 0-.089.034.053.053 0 0 0-.012.017Z",
        fill: l ? r(o, 0, "#262933") : "#262933",
        datafollowfill: l ? r(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, k = s;
export {
  k as default
};
